<form [formGroup]="editForm" class="k-form-inline">

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="student_institution_id"> Student Institution ID</label>
    <div class="col-8">
      <input type="text" id="student_institution_id" formControlName="student_institution_id" class="form-control"
        appAutoFocus>
      @if(student_institution_id?.invalid) {
      <div class="alert alert-danger">
        @if(student_institution_id?.errors?.['required']) {
        <div>Student Institution ID is required.</div>
        }
      </div>
      }
    </div>
  </div>
  <!--
  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="student_email"> Student Email</label>
    <div class="col-8">
      <input type="text" id="student_email" formControlName="student_email" class="form-control"
        style="text-transform: lowercase;" [readonly]="mode === formModes.EDIT">
      @if(student_email?.invalid || editForm.errors?.['duplicateReviewStudent']){
      <div class="alert alert-danger">
        @if(student_email?.errors?.['required']){
        <div>Student Email is required.</div>
        }
        @if(student_email?.errors && student_email?.errors?.['email']){
        <div>Please, enter valid email address.</div>
        }
        @if(editForm.errors?.['duplicateReviewStudent']) {
        <div>
          Student is already allocated to this Review.
        </div>
        }
        @if(student_email?.hasError('compareNotMatch')){
        <div>Student & Additional Supervisor email cannot be the same.</div>
        }
      </div>

      }
    </div>
  </div> -->

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="student_email_search">Student Email</label>
    <div class="col-8">
      <casi-email-search id="student_email_search" forId="student_email_search" [inputEmail]="student_email?.value"
        (onSearched)="onStudentEmailSearched($event)" appAutoFocus
        [readOnly]="mode === formModes.EDIT"></casi-email-search>
      <input type="text" id="student_email" formControlName="student_email" class="form-control"
        style="text-transform: lowercase;" readonly="true" hidden>
      @if(student_email?.invalid || editForm.errors?.['duplicateReviewStudent']){
      <div class="alert alert-danger">
        @if(student_email?.errors?.['required']){
        <div>Student Email Address is required.</div>
        }
        @if(student_email?.errors && student_email?.errors?.['email']){
        <div>Please, enter valid email address.</div>
        }
        @if(student_email?.hasError('compareNotMatch')){
        <div>Student & Additional Supervisor email cannot be the same.</div>
        }
        @if(editForm.errors?.['duplicateReviewStudent']) {
        <div>
          Student is already allocated to this Review.
        </div>
        }
      </div>
      }
    </div>
  </div>

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="student_first_name">Student<br> First Name</label>
    <div class="col-8">
      <input type="text" id="student_first_name" formControlName="student_first_name" class="form-control"
        [readonly]="studentIsLocked">
    </div>
  </div>

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="student_last_name">Student<br> Last Name</label>
    <div class="col-8">
      <input type="text" id="student_last_name" formControlName="student_last_name" class="form-control"
        [readonly]="studentIsLocked">
      @if(student_last_name?.hasError('firstOrLastNameRequired')){
      <div class="alert alert-danger">
        <div>First name or last name is required.</div>
      </div>
      }
    </div>
  </div>

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="supervisor_email_search">Primary Supervisor Email Address</label>
    <div class="col-8">
      <casi-email-search id="supervisor_email_search" forId="supervisor_email_search"
        [inputEmail]="supervisor_email?.value" (onSearched)="onEmailSearched($event)" appAutoFocus></casi-email-search>
      <input type="text" id="supervisor_email" formControlName="supervisor_email" class="form-control"
        style="text-transform: lowercase;" readonly="true" hidden>
      @if(supervisor_email?.invalid){
      <div class="alert alert-danger">
        @if(supervisor_email?.errors?.['required']){
        <div>Primary Supervisor Email Address is required.</div>
        }
        @if(supervisor_email?.errors && supervisor_email?.errors?.['email']){
        <div>Please, enter valid email address.</div>
        }
        @if(supervisor_email?.hasError('compareNotMatch')){
        <div>Student & Primary Supervisor email cannot be the same.</div>
        }
      </div>
      }
    </div>
  </div>

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="supervisor_first_name">Primary Supervisor<br> First Name</label>
    <div class="col-8">
      <input type="text" id="supervisor_first_name" formControlName="supervisor_first_name" class="form-control"
        [readonly]="primaryIsLocked">
    </div>
  </div>

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="supervisor_last_name">Primary Supervisor<br> Last Name</label>
    <div class="col-8">
      <input type="text" id="supervisor_last_name" formControlName="supervisor_last_name" class="form-control"
        [readonly]="primaryIsLocked">
      @if(supervisor_last_name?.hasError('firstOrLastNameRequired')){
      <div class="alert alert-danger">
        <div>First name or last name is required.</div>
      </div>
      }
    </div>
  </div>
  <!-- <div>
      form values: {{editForm.value | json }}<br>
      <br>
    </div> -->
  <!-- <pre>{{ editForm.errors | json }}</pre>
    <pre>supervisor_last_name: {{ supervisor_last_name?.hasError('firstOrLastNameRequired')  }}</pre>
    <pre>additional_supervisor_last_name: {{ additional_supervisor_last_name?.hasError('firstOrLastNameRequired')  }}</pre>
    <pre>additional_supervisor_email: {{ additional_supervisor_email?.hasError('compareNotMatch')  }}</pre>
    <pre>form invalid: {{ editForm.invalid | json }}</pre> -->
  <!-- <pre>{{ editForm.hasError('firstOrLastName3Required') }}</pre> -->

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="additional_supervisor_email_readyonly">Secondary Supervisor Email
      Address</label>
    <div class="col-8">
      <casi-email-search id="additional_supervisor_email_search" forId="additional_supervisor_email_search"
        [inputEmail]="additional_supervisor_email?.value"
        (onSearched)="onEmailSearchedSecondary($event)"></casi-email-search>
      <input type="text" id="additional_supervisor_email" formControlName="additional_supervisor_email"
        class="form-control" style="text-transform: lowercase;" readonly="true" hidden>
      @if(additional_supervisor_email?.invalid){
      <div class="alert alert-danger">
        @if(additional_supervisor_email?.errors && additional_supervisor_email?.errors?.['email']){
        <div>Please, enter valid email address.</div>
        }
        @if(additional_supervisor_email?.hasError('compareNotMatch')){
        <div>Primary & Secondary Supervisor email cannot be the same.</div>
        }
      </div>
      }
    </div>
  </div>
  <!-- <pre>has secondary: {{hasSecondary()}}</pre> -->
  @if(hasSecondary()){

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="additional_supervisor_first_name">Secondary Supervisor First
      Name</label>
    <div class="col-8">
      <input type="text" id="additional_supervisor_first_name" formControlName="additional_supervisor_first_name"
        class="form-control" [readonly]="secondaryIsLocked">
    </div>
  </div>

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="additional_supervisor_last_name">Secondary Supervisor Last
      Name</label>
    <div class="col-8">
      <input type="text" id="additional_supervisor_last_name" formControlName="additional_supervisor_last_name"
        class="form-control" [readonly]="secondaryIsLocked">
      @if(additional_supervisor_last_name?.hasError('firstOrLastNameRequired')){
      <div class="alert alert-danger">
        <div>First name or last name is required.</div>
      </div>
      }
    </div>
  </div>
  }

</form>

<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="editForm.invalid">Save</button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>
